import { render } from "./TraderDashboard.vue?vue&type=template&id=83abf38c&ts=true"
import script from "./TraderDashboard.vue?vue&type=script&lang=ts"
export * from "./TraderDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__